import React from "react";
import ReportColumnChart from "./ReportColumnChart";
import ReportPieChart from "./ReportPieChart";
import ReportCatgoryChart from "./ReportCatgoryChart";
import ReportReturningChart from "./ReportReturningChart";
import { GraphDataMaker } from "../../../util/helper/graph";

export const getSplitRatio = (short)=> (short ? 0.6 : 0.5);

const PieObjectChart = (props)=>{
	const { data = {}, previousData, removeZero } = props;
	return <ReportPieChart
		{...props}
		data={GraphDataMaker.makeRenderDataOfObject(data, GraphDataMaker.strToLabel, (k,v)=>v, removeZero)}
		previousData={!previousData ? undefined :
			GraphDataMaker.makeRenderDataOfObject(previousData, GraphDataMaker.strToLabel, (k,v)=>v, removeZero)
		}
	/>;
};

const ColumnObjectChart = (props)=>{
	const { data = {}, previousData, removeZero } = props;
	return <ReportColumnChart
		{...props}
		data={GraphDataMaker.makeRenderDataOfObject(data, GraphDataMaker.strToLabel, (k,v)=>v, removeZero)}
		previousData={!previousData ? undefined : 
			GraphDataMaker.makeRenderDataOfObject(previousData, GraphDataMaker.strToLabel, (k,v)=>v, removeZero)}
	/>;
};
/**
 * Note that for now only column chart has translate feature.
 */


export default { 
	ReportPieChart, 
	ReportColumnChart, 
	ReportPieObjectChart: PieObjectChart,
	ReportColumnObjectChart: ColumnObjectChart,
	ReportCatgoryChart,
	ReportReturningChart
};


// WEBPACK FOOTER //
// ./src/components/report/generics/index.js